import React from 'react';
import styles from './styles.module.scss';
import { FaExclamationTriangle, FaLightbulb, FaTimes } from 'react-icons/fa';

interface RulesAndTipsProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const RulesAndTips: React.FC<RulesAndTipsProps> = ({ isOpen, onClose, onContinue }) => {
  if (!isOpen) return null;

  // Stop propagation to prevent clicks from reaching backdrop
  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div 
      className={styles.modalBackdrop} 
      onClick={onClose} // Close when clicking the backdrop
    >
      <div 
        className={styles.modalContent} 
        onClick={handleContentClick}
      >
        <div className={styles.header}>
          <h2 className={styles.title}>Rules & Tips</h2>
          <button 
            className={styles.closeButton} 
            onClick={onClose}
            aria-label="Close dialog"
          >
            <FaTimes />
          </button>
        </div>
        
        <div className={styles.warningSection}>
          <FaExclamationTriangle className={styles.warningIcon} />
          <p className={styles.warningText}>
          Any violation of our Terms, including the use of illegal methods (VPNs, cheats, hacks), will be detected and result in no payout.
          </p>
        </div>
        
        <div className={styles.tipsSection}>
          <div className={styles.tipItem}>
            <FaLightbulb className={styles.tipIcon} />
            <p>Making in-app purchases can help you achieve goals faster and generate more cash!</p>
          </div>
          <div className={styles.tipsList}>
            <ul>
              <li>Only first-time app installs are eligible.</li>
              <li>Goals must be completed within specific timeframes.</li>
              <li>Most rewards are reviewed within a few hours, but some may take up to 10 days.</li>            </ul>
          </div>
        </div>
        
        <div className={styles.footer}>
          <button 
            className={styles.continueButton} 
            onClick={onContinue}
          >
            I Agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default RulesAndTips;